<div class="site-footer">
  <div class="container">

    <!-- LOGO -->
        <div class="text-center mb-4">
    <a class="mobile-header__logo" routerLink="menu">
        <img *ngIf="logo" [src]="logo" alt="Logo azienda" class="footer-logo" style="object-fit: contain;">
        <span *ngIf="!logo" class="azienda-label-small">{{ nome }}</span>
    </a>
    </div>

    <!-- BOX INFORMAZIONI -->
    <div class="info-box mb-4"
        *ngIf="boxInfo?.title || boxInfo?.subtitle || boxInfo?.message">
    <h3>{{ boxInfo.title }}</h3>
    <p><em>{{ boxInfo.subtitle }}</em></p>
    <div [innerHTML]="boxInfo.message"></div>
    </div>


    <!-- SEGUICI + SOCIAL -->
    <div *ngIf="socialLinks?.length" class="d-flex justify-content-between align-items-center mb-4 footer-row">
    <p class="footer-section-title mb-0">{{ 'FOOTER.FOLLOW_US' | translate }}</p>
    <div class="social-icons">
        <a *ngFor="let social of socialLinks" [href]="social.url || '#'" target="_blank" rel="nofollow">
        <i [class]="social.iconClass"></i>
        </a>
    </div>
    </div>


    <!-- CONTATTACI + INFO affiancati -->
    <div class="d-flex justify-content-between align-items-start footer-contact-info mb-4 flex-wrap">
    <div class="footer-block">
        <p class="footer-section-title">{{ 'FOOTER.CONTACTS' | translate }}</p>
        <ul class="footer-contacts__contacts">
        <li *ngIf="storeService.email">{{ storeService.email }} </li>
        <li *ngIf="storeService.phone?.length">{{ storeService.phone.join(', ') }}</li>
        <li *ngIf="storeService.partita_iva">P.IVA {{ storeService.partita_iva }}</li>
        </ul>
    </div>

    <div class="footer-block">
    <p class="footer-section-title">{{ 'FOOTER.INFORMATION' | translate }}</p>
    <ul class="footer-links__list">
        <li *ngFor="let link of infoLinks">
        <a [href]="link.url" [attr.rel]="link.no_follow ? 'nofollow' : null">
            {{ link.label }}
        </a>
        </li>
    </ul>
    </div>
    </div>

        <div class="site-footer__payments mb-3">
    <img src="assets/images/payments.png" alt="Metodi di pagamento accettati">
    </div>


    <!-- POWERED BY -->
    <div class="site-footer__bottom mt-4">
      <div class="site-footer__copyright">
    Powered by <a href="http://mytidy.it/" target="_blank" rel="nofollow"><strong>MyTidy</strong></a>
    </div>
    </div>
  </div>
</div>
